import {createSelector} from '@reduxjs/toolkit'

import {isEmpty} from '@shared/helpers/lang'

import {APIStatus} from '@web/core/constants'

import {RootState} from './interfaces'

const saleSettlementSelector = (state: RootState) => state.saleSettlement

export const saleSettlementInfoSelector = createSelector(saleSettlementSelector, ({method}) => {
    return {
        method,
    }
})

export const saleSettlementSummarySelector = createSelector(
    (state: RootState) => state.saleSettlement.summary,
    ({complete, expect, detail}) => {
        return {
            complete,
            expect,
            detail,
        }
    },
)

export const saleSettlementPayHoldSelector = createSelector(
    (state: RootState) => state.saleSettlement.payHold,
    ({selected, items, totalAmount, status}) => {
        const isRejected = status === APIStatus.REJECTED
        const isEmptyResult = isEmpty(items)

        return {
            selected,
            items,
            totalAmount,
            isRejected,
            isEmptyResult,
        }
    },
)
